/**
 * Grenzwandler Navigation Sidebar
 * Desktop: fixed right sidebar (36px → 250px)
 * Mobile: 3-dot trigger → fullscreen overlay
 */
(function () {
  var sidebar = document.getElementById('gwNavSidebar');
  var trigger = sidebar && sidebar.querySelector('.gw-nav-trigger');
  var panel = sidebar && sidebar.querySelector('.gw-nav-panel');
  var closeBtn = sidebar && sidebar.querySelector('.gw-nav-panel__close');
  var toursToggle = sidebar && sidebar.querySelector('.gw-nav-tours-toggle');
  var toursPanel = sidebar && sidebar.querySelector('.gw-nav-tours');
  var arrow = toursToggle && toursToggle.querySelector('.gw-nav-tours-arrow');

  if (!sidebar) return;
  // trigger may be hidden on mobile, but sidebar must exist

  function isMobile() {
    return window.innerWidth < 768;
  }

  function open() {
    sidebar.classList.add('is-open');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    // Only lock body scroll on mobile (fullscreen overlay)
    if (isMobile()) {
      document.body.style.overflow = 'hidden';
      // Close Ghost's default mobile menu if open
      var ghNav = document.getElementById('gh-navigation');
      if (ghNav) ghNav.classList.remove('is-open');
    }
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    sidebar.classList.remove('is-open');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // Also collapse tours when closing
    if (toursPanel && toursPanel.classList.contains('is-expanded')) {
      toursPanel.classList.remove('is-expanded');
      toursPanel.setAttribute('aria-hidden', 'true');
      if (toursToggle) toursToggle.setAttribute('aria-expanded', 'false');
      if (arrow) arrow.textContent = '\u2193';
    }
    if (trigger) trigger.focus();
  }

  function toggleTours() {
    if (!toursPanel) return;
    var expanded = toursPanel.classList.toggle('is-expanded');
    toursPanel.setAttribute('aria-hidden', String(!expanded));
    if (toursToggle) toursToggle.setAttribute('aria-expanded', String(expanded));
    if (arrow) arrow.textContent = expanded ? '\u2190' : '\u2193';
  }

  // Open sidebar (desktop: 3-dot trigger)
  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      open();
    });
  }

  // Mobile: hamburger opens custom sidebar panel instead of Ghost menu
  var burger = document.querySelector('.gh-burger');
  if (burger) {
    burger.addEventListener('click', function (e) {
      if (isMobile()) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (sidebar.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      }
    }, true);
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  // Tours toggle
  if (toursToggle) {
    toursToggle.addEventListener('click', function (e) {
      e.preventDefault();
      toggleTours();
    });
  }

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
      close();
    }
  });

  // Close when clicking a nav link (navigate away)
  if (panel) {
    var navLinks = panel.querySelectorAll('a[href]');
    for (var i = 0; i < navLinks.length; i++) {
      navLinks[i].addEventListener('click', function () {
        close();
      });
    }
  }

  // Desktop: close when clicking outside sidebar
  document.addEventListener('click', function (e) {
    if (!isMobile() && sidebar.classList.contains('is-open') && !sidebar.contains(e.target)) {
      close();
    }
  });

  // === Code Injection overrides ===
  // window.navOverrides = { karte: { text: 'Map', url: '/map/' }, projekt: { text: 'About' } }
  var overrides = window.navOverrides;
  if (overrides) {
    var items = sidebar.querySelectorAll('[data-nav-id]');
    for (var j = 0; j < items.length; j++) {
      var navId = items[j].getAttribute('data-nav-id');
      if (overrides[navId]) {
        if (overrides[navId].text) {
          // Preserve arrow span for tours toggle
          var arrowSpan = items[j].querySelector('.gw-nav-tours-arrow');
          if (arrowSpan) {
            items[j].textContent = overrides[navId].text + ' ';
            items[j].appendChild(arrowSpan);
          } else {
            items[j].textContent = overrides[navId].text;
          }
        }
        if (overrides[navId].url && items[j].href !== undefined) {
          items[j].href = overrides[navId].url;
        }
      }
    }
  }
})();
